import $ from 'jquery';
import apiFetch from '@wordpress/api-fetch';
import Cookies from 'js-cookie';

const $body = $('body');

reloadScriptProject();

export function reloadScriptProject() {
    const $notFound = $('.project__not-found');

    if ($notFound.length > 0) {
        $notFound.each(function () {
            notFound($(this));
        });
    }

    const $found = $('.project__found');

    if ($found.length > 0) {
        $found.each(function () {
            found($(this));
        });
    }

    const $info = $('.project-info');

    if ($info.length > 0) {
        $info.each(function () {
            projectInfo($(this));
        });
    }
}


function notFound(element) {
    if (Cookies.get('poll_liked_' + element.data('project')) !== undefined) {
        element.closest('.project__clarity').addClass('project__clarity--clicked');
        return;
    }

    element.off('click');
    element.on('click', function () {
        const $issues = element.parent().children('.project__not-found-issues');

        if ($issues.is(':hidden')) {
            $issues.slideDown(300, () => {
                $body.one('click', () => {
                    $issues.slideUp(300);
                });
            });
        } else {
            $issues.slideUp(300);
        }

        $issues.off('click');

        const $issue = $issues.children('.project__not-found-issue');

        $issue.on('click', async function () {
            const $thisEl = $(this);
            const projectId = $thisEl.data('project');

            const data = {
                projectId: projectId,
                like: 'false',
                msg: $thisEl.val(),
            };

            const result = await voteLike(data);

            Cookies.set('poll_liked_' + projectId, 'true');

            if (result === true) {
                const event = new CustomEvent('alert', {
                    detail: {
                        type: 'alert--success',
                        msg: 'Děkujeme za zpětnou vazbu.',
                        msgEn: 'Thank you for the feedback.',
                    },
                });
                document.dispatchEvent(event);

                element.closest('.project__clarity').addClass('project__clarity--clicked');
            }
        });
    });
}

function found(element) {
    if (Cookies.get('poll_liked_' + element.data('project')) !== undefined) {
        element.closest('.project__clarity').addClass('project__clarity--clicked');
        return;
    }

    element.off('click');
    element.on('click', async function () {
        const $thisEl = $(this);
        const projectId = $thisEl.data('project');

        const data = {
            projectId: projectId,
            like: 'true',
        };

        const result = await voteLike(data);

        Cookies.set('poll_liked_' + projectId, 'true');

        if (result === true) {
            const event = new CustomEvent('alert', {
                detail: {
                    type: 'alert--success',
                    msg: 'Děkujeme za zpětnou vazbu.',
                    msgEn: 'Thank you for the feedback.',
                },
            });
            document.dispatchEvent(event);

            element.closest('.project__clarity').addClass('project__clarity--clicked');
        }
    });
}

function projectInfo(element) {
    const $perex = element.find('.project-info__item-perex');

    if ($perex.length > 0) {
        $perex.each(function () {
            splitPerex($(this));
        });
    }

    // const $container = element.closest('.project__container');

    // if ($container) {
    //     const outerHTML = element.get(0).outerHTML;
    //     element.remove();
    //     $container.before(outerHTML);
    // }
}

function splitPerex(element) {
    if (element.length > 0) {
        const words = element.html().split(' ');
        const count = words.length;
        const treshold = Math.ceil(count / 2);

        let firstHalf = '<div>';
        for (let index = 0; index < treshold; index++) {
            firstHalf += words[index].replace(/\s/g, '');

            if (index < treshold - 1) {
                firstHalf += ' ';
            } else {
                firstHalf += '</div>';
            }
        }
        let secondHalf = '<div>';
        for (let index = treshold; index < count; index++) {
            secondHalf += words[index].replace(/\s/g, '');

            if (index < count - 1) {
                secondHalf += ' ';
            } else {
                secondHalf += '</div>';
            }
        }

        secondHalf === '<div>' ? element.html(firstHalf) : element.html(firstHalf + secondHalf);
    }
}
